var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJodTextWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 20,
    viewBox: "0 0 42 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28_325)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.77383 0C5.72452 0 4.90594 0.815098 4.90594 1.85996C4.90594 2.90481 5.74649 3.71991 6.77383 3.71991C7.80117 3.71991 8.64172 2.86652 8.64172 1.85996C8.64172 0.853392 7.80117 0 6.77383 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.24657 12.2594C5.24657 14.8305 3.13695 16.9421 0.543885 16.964H0V20.0001H0.549379C4.82354 20.0001 8.30111 16.5263 8.30111 12.2594V4.80859H5.25206V12.2594H5.24657Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3988 4.54053C13.1137 4.54053 9.62512 8.00333 9.62512 12.2539C9.62512 16.5044 13.1137 19.9946 17.3988 19.9946C21.684 19.9946 25.1451 16.5208 25.1451 12.2539C25.1451 7.98692 21.6675 4.54053 17.3988 4.54053ZM22.096 12.2539C22.096 14.8469 19.9864 16.9585 17.3988 16.9585C14.8113 16.9585 12.6742 14.8469 12.6742 12.2539C12.6742 9.66088 14.7948 7.57663 17.3988 7.57663C20.0029 7.57663 22.096 9.67729 22.096 12.2539Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9509 0V6.12691C37.605 5.10941 35.9513 4.54595 34.2537 4.54595C29.9686 4.54595 26.48 8.00875 26.48 12.2593C26.48 16.5098 29.9686 20 34.2537 20C38.5389 20 42 16.5263 42 12.2593V0H38.9509ZM38.9509 12.2593C38.9509 14.8523 36.8413 16.9639 34.2537 16.9639C31.6662 16.9639 29.5291 14.8523 29.5291 12.2593C29.5291 9.6663 31.6497 7.58206 34.2537 7.58206C36.8578 7.58206 38.9509 9.68271 38.9509 12.2593Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28_325"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJodTextWhite);
export default __webpack_public_path__ + "static/media/JodTextWhite.2d1187491445bc6f33a2aecabd5626ca.svg";
export { ForwardRef as ReactComponent };